import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { NotFoundState } from "@/components/ui/not-found-state";
import { useNavigate } from "@tanstack/solid-router";

/**
 * Router's global `defaultNotFoundComponent`: any unknown URL shows
 * this state instead of a blank screen. It renders inside the
 * root's `<Outlet>` (with all providers available).
 */
export function NotFoundRoute() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <div data-testid="not-found-route" class="flex min-h-0 flex-1 items-center justify-center">
      <NotFoundState
        variant="not-found"
        title={t(msg`Page not found`)}
        description={t(msg`The page you're looking for doesn't exist or has moved.`)}
        primaryAction={{
          label: t(msg`Go home`),
          onClick: () => {
            void navigate({ to: "/" });
          },
        }}
      />
    </div>
  );
}
